import axios from 'axios';


export const makeApiCall = async (method = null, payload = null, apiUrl = null) => {
    try {
        let token = localStorage.getItem('token');
        console.log("final url", apiUrl);
        const axiosRes = await axios({
            method: method,
            headers: { "x-access-token": `${token}` },
            url: apiUrl,
            data: payload,
        });
        console.log("API called [SUCCESS]", axiosRes.data);
        return axiosRes?.data;
    } catch (err) {
        console.log("API called [ERROR]", err);
        return err;
    }
}
